import { RemoteService } from "../../@uno/api";

const fileCache: any = {};

const getFile = (fileId: string) => {
    const file = fileCache[fileId];
    if (file) {
        return fileId; // file;
    } else {
        // initiate the caching process
        // _cacheFile(fileId);
        return fileId;
    }
}

const _cacheFile = async (url: string) => {
    const resp = await RemoteService.getData(await RemoteService.get(url, undefined,));
    console.log('FileCacheService Response: ', url, resp);
    if (resp) {
        fileCache[url] = resp;
    }
}

const setFile = (fileId: string, file: any) => {
    fileCache[fileId] = file;
}

const clearFile = (fileId: string) => {
    delete fileCache[fileId];
}


const clearAllFiles = () => {
    for (const key in fileCache) {
        delete fileCache[key];
    }
}

const getAllFiles = () => {
    return fileCache;
}

export const FileCacheService = {
    getFile: getFile,
    // setFile: setFile,
    clearFile: clearFile,
    clearAllFiles: clearAllFiles,
    // getAllFiles: getAllFiles,
};